export const runTerminalCommand = (toolMessage: any, results: any, toolName: string) => {
    const textContent = toolName === "runTerminalCommand" ?
        "Command successfully run! Here is the output of it" :
        "Here is the current state of the terminal's output";

    const content = [{
        type: 'text',
        text: `${textContent}:\n\`\`\`\n${results.output}\n\`\`\``
    }];
    const truncatedContent = [{
        type: 'text',
        text: `${textContent}:\n\`\`\`\n<Truncated for brevity>\n\`\`\``
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
